import { render, staticRenderFns } from "./FirstReportSection.vue?vue&type=template&id=20a83909&"
import script from "./FirstReportSection.vue?vue&type=script&lang=js&"
export * from "./FirstReportSection.vue?vue&type=script&lang=js&"
import style0 from "./FirstReportSection.vue?vue&type=style&index=0&id=20a83909&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports